<template>
  <v-dialog @click:outside="closeModal()" v-model="dialog" max-width="700">
    <v-card class="vpd-dialog">
      <v-card-title class="headline">
        Hogyan tovább?
      </v-card-title>
      <v-card-subtitle class="subtitle-1 pt-6">
        <p>A BinX számlád csatlakozási kérelmét elindítottuk.</p>
        <p>A kérelem <strong>jóváhagyását a BinX alkalmazásban tudod folytatni</strong>. A BinX erről egy <strong>push üzenetet</strong> is küldött neked.</p>
        <p>Ha esetleg nem kaptál push üzenetet, ne aggódj! Egyszerűen nyisd meg a BinX appot, lépj be, majd a kezdőoldalon a '<strong>Feladatok</strong>' között ellenőrizheted és hagyhatod jóvá a kérést.</p>
        <p>Fontos: <strong>10 perced van a jóváhagyásra</strong>, ezért kérjük, minél előbb intézd el!</p>
        <p>A jóváhagyás után kattints a <strong>frissítés</strong> gombra!</p>
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="secondary uppercase v-btn--has-bg theme--light" text @click="$emit(event)">
          Frissítés
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import "./_vpd-binx-confirm-dialog.scss";

export default {
  name: "vpd-binx-confirm-dialog",
  methods: {
    handleSubmit(event) {
      this.$emit(event);
    },
    closeModal() {
      this.$emit('close-modal');
    }
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    event: {
      type: String,
      required: true,
    },
  },
};
</script>
